// 共通ボタンスタイル定数

/**
 * グレー系の削除ボタンスタイル
 * 危険度の低い削除操作やキャンセル操作に使用
 */
export const SECONDARY_DELETE_BUTTON_STYLE = {
  color: 'text.secondary',
  borderColor: 'grey.400',
  '&:hover': {
    borderColor: 'grey.600',
    backgroundColor: 'grey.50',
  },
} as const

/**
 * グレー系のIconButtonスタイル
 * 削除・編集・その他の操作アイコンに使用
 */
export const SECONDARY_ICON_BUTTON_STYLE = {
  color: 'text.secondary',
  '&:hover': {
    color: 'text.primary',
    backgroundColor: 'grey.100',
  },
} as const
